<template>
    <div class="nav-container" id="nav-container">
		 <div class="burgerBg" id="buger">
			<div class="burger" v-on:click="attachNav = !attachNav" v-bind:class="{open: attachNav}">
			<span></span>
			<span></span>
			<span></span>
			</div>
		</div>
		<nav class="menu" id="menu" v-bind:class="{open: attachNav}">
			<ul>
				<li><router-link v-on:click.native="handleScroll" class="nav-link" :to="{ path: '/Top10'}" >首頁</router-link></li>
				<!-- <li><router-link v-on:click.native="handleScroll" class="nav-link" :to="{ path: '/vote/tovote'}">人氣口碑獎</router-link></li> -->
				<li><router-link v-on:click.native="handleScroll" class="nav-link" :to="{ path: '/Popular/result'}">人氣口碑獎</router-link></li>
				<li><router-link v-on:click.native="handleScroll" class="nav-link" :to="{ path: '/Expert'}">專業評審獎</router-link></li>
				<li><router-link v-on:click.native="handleScroll" class="nav-link" :to="{ path: '/Man'}">COSMO型男最推</router-link></li>
				<li><router-link v-on:click.native="handleScroll" class="nav-link" :to="{ path: '/Asiatop10'}">ASIA TOP 10</router-link></li>
				<!-- <li><router-link class="nav-link fbBtn" :to="{ path: '/vote'}"><i class="fa fa-facebook" aria-hidden="true"></i></router-link></li> -->
				<li><a v-on:click.native="handleScroll" class="nav-link fbBtn" v-on:click="initfb()"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
			</ul>
		</nav>
	</div>
	
</template>
<script>
export default {
  name: 'nav-container',
  data () {
	return {
	  attachNav: false,
	  scrolled: false,
	  fbFlag: false
    }
  },
  created() {
	  window.addEventListener('scroll', this.handleScroll)
	//   window.scrollY == 0

  },
  mounted(){
	//   console.log("nav m")
  },
  destroyed () {
	  window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
	handleScroll () {
		let self = this
		self.scrolled = window.scrollY > 0
		self.attachNav = false
		
	},
	initfb(){
		let self = this
		let app_id = "1773345512896290"; 
		// 目前是測試1717066635240445 上正式機 要替換為 1773345512896290 
		//$("meta[property='fb:app_id']").attr('data-scope')
		//$("meta[property='fb:app_id']").attr("content")
		if(location.href.indexOf("http://c.hearst-taiwan.com.tw/2017/beautyawards/")!=-1){
			app_id = '1717066635240445'
			// console.log("app_id"+app_id)
		}
		if(self.fbFlag != true){
			window.$fb = new $.facebookr({
				version: 'v2.9',
				appId: app_id,
				scope: 'email,public_profile,user_birthday',
				onLoad: function() {
					self.fbFlag = true
					self.share()
				}
			});  
		}else{
			self.share()
		}

		 
	},
	share() {
		let app_id = "1773345512896290"; 
			// 目前是測試1717066635240445 上正式機 要替換為 1773345512896290 
			//$("meta[property='fb:app_id']").attr('data-scope')
			//$("meta[property='fb:app_id']").attr("content")
			if(location.href.indexOf("http://c.hearst-taiwan.com.tw/2017/beautyawards/")!=-1){
				app_id = '1717066635240445'
				// console.log("app_id"+app_id)
			}
		let url = location.href
		window.$fb.share({
			app_id: app_id,
			link: url,
			quote: '' ,
			display: "popup",
			redirect_uri: url
		}, function() {})
	}
  }
}
</script>


<style lang="sass">
$main-color: #f21290
.burgerBg.open 
	border: 1px solid transparent
.burgerBg
	position: fixed
	left: calc(50vw + 530px)
	z-index: 102
	width: 40px
	height: 40px
	margin-left: 10px
	// border: 1px solid #fff 
	margin-top: 10px

	.burger
		width: calc(100% - 10px)
		height: 100%
		margin: 0 5px
		position: relative
		transform: rotate(0deg)
		transition: .5s ease-in-out
		cursor: pointer
		span
			display: block
			position: absolute
			height: 2px
			width: 100%
			background: $main-color
			border-radius: 4px
			opacity: 1
			left: 0
			transform: rotate(0deg)
			transition: .25s ease-in-out
	.burger span:nth-child(1) 
		top: 11px
	.burger span:nth-child(2) 
		top: 18px
	.burger span:nth-child(3) 
		top: 25px
	.burger.open span:nth-child(1) 
		top: 20px
		transform: rotate(135deg)
		// background-color: #fff
	.burger.open span:nth-child(2) 
		opacity: 0
		left: -60px
		// background-color: #fff
	.burger.open span:nth-child(3) 
		top: 20px
		transform: rotate(-135deg)
		// background-color: #fff

.menuBox
	position: fixed
	height: 50px
	width: 100vw
	// max-width: $max-w-mobile
	z-index: 101
	transition: background-color .2s linear
	.logo
		display: block
		position: absolute
		left: 70px
		top: 32%
		width: 150px
// --------------
.menuBox.open
	background-color: #1c1e1c
// --------------

//nav menu-----------------------
.menu 
	z-index: 100
	position: fixed
	background-color: rgba(0,0,0,0.9)
	top: 0
	left: 0
	width: 100vw
	height: 0
	opacity: 0
	visibility: hidden
	transition: opacity .35s, visibility .35s, height .35s
	overflow: hidden
	display: flex
	align-content: center
	justify-content: center
	&.open 
		opacity: 1
		visibility: visible
		height: 100vh
		li 
			animation: fade-right .3s ease forwards
			animation-delay: .35s
			&:nth-of-type(1) 
				animation-delay: .4s		
				opacity: 1
			&:nth-of-type(2) 
				animation-delay: .45s		
				opacity: 1
			&:nth-of-type(3) 
				animation-delay: .5s
				opacity: 1
			&:nth-of-type(4) 
				animation-delay: .55s
				opacity: 1
			&:nth-of-type(5) 
				animation-delay: .6s
				opacity: 1
			&:nth-of-type(6) 
				animation-delay: .65s
				opacity: 1
  
	ul 
		list-style: none
		padding: 0
		margin: 0 auto
		display: inline-block
		position: relative
		margin-top: 50px
		text-align: center
		// width: 100%
		width: 500px
		font-weight: bold
	li 
		display: block
		height: 60px
		position: relative
		opacity: 0
		margin: 0 25px
		text-align: left
		// transform: translateX(50%)
	a 
		font-size: 20px
		line-height: 20px
		letter-spacing: 0.025em
		font-weight: 300
		display: block
		position: relative
		color: $main-color
		text-decoration: none
		// overflow: hidden 
		padding: 13px 0
		cursor: pointer
		text-align: center
		position: relative
		&:hover:after,
		&:focus:after,
		&:active:after 
			width: 100%
		&:after 
			content: ''
			position: absolute
			bottom: 0
			left: 0
			width: 100%
			// transform: translateX(-50%)
			transform: rotate(355deg)
			height: 1px
			background: $main-color
			opacity: 0.5
			transition: .35s
	.fbBtn
		i 
			font-size: 30px
			color: $main-color 
		&:after
			opacity: 0

@media only screen and (max-width: 1080px) 
	.menu ul 
		width: 100%

@keyframes(fade-right) 
	0% 
		opacity: 0
		transform: translateX(0%)

	100% 
		opacity: 1
		transform: translateX(0%)

@media only screen and (max-width: 1200px)
	.burgerBg
		right: 30px
		top: 30px
		left: auto
		transform: scale(2)
	.menu 
		ul 
			margin-top: 40%
		li 
			height: 108px
		a
			font-size: 44px
			font-weight: 500
			line-height: 108px
			height: 100%
			padding: 0
			&:after
				transform: none
		.fbBtn i 
			font-size: 50px
</style>



// WEBPACK FOOTER //
// Navbar.vue?24603c5a